import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=5be10bf2&scoped=true"
import script from "./TableChart.vue?vue&type=script&lang=js"
export * from "./TableChart.vue?vue&type=script&lang=js"
import style0 from "./TableChart.vue?vue&type=style&index=0&id=5be10bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be10bf2",
  null
  
)

export default component.exports